
import React from 'react';

const stats = [
  { number: '20+', label: 'Years Experience', icon: 'ri-time-line' },
  { number: '50K+', label: 'Machines Sold', icon: 'ri-truck-line' },
  { number: '120+', label: 'Countries Served', icon: 'ri-global-line' },
  { number: '99%', label: 'Customer Satisfaction', icon: 'ri-heart-line' },
];

const StatsSection = () => {
  // Defensive check – ensure stats is an array before mapping
  if (!Array.isArray(stats) || stats.length === 0) {
    return null; // nothing to render
  }

  return (
    <section className="py-20 bg-white relative -mt-16 z-10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white rounded-3xl shadow-xl shadow-gray-200/50 p-8 md:p-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-14 h-14 mx-auto mb-4 bg-emerald-50 rounded-2xl flex items-center justify-center">
                  <i className={`${stat.icon} text-2xl text-emerald-500`}></i>
                </div>
                <div className="text-3xl md:text-4xl font-bold text-gray-900 mb-1">{stat.number}</div>
                <div className="text-sm text-gray-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
